import React from 'react';
import { Button, Card, Paper, Typography } from "@mui/material";
import '../../../App.css'
import Bias from '../../Shared/Bias';
import moment from 'moment';
import { useNavigate } from "react-router-dom";

const InjectedReducedCard = ({title, description, clickEv, evText}) => {
    return(
        <Card style={{backgroundColor:'#121a1c', display:'flex', alignItems:'center', margin:'3px auto'}} className={'reducedCard'}>
            <div style={{flex:4, height:'100%', flexDirection:'row', padding:'10px', justifyContent:'space-between', verticalAlign:'middle'}}>
                <div>
                    <Typography gutterBottom variant="p" style={{ fontWeight: '600', textAlign: 'start', flex:2 }} component="div">
                        {title}
                    </Typography>
                    <div style={{flex:1}}>
                        <Typography gutterBottom variant="p" color={'text.secondary'} style={{textAlign: 'start', fontSize:'13px'}} component="div">
                            {description}
                        </Typography>
                    </div>
                </div>
            </div>
            <div style={{flex:1, height:'100%', flexDirection:'row', padding:'10px', justifyContent:'space-between',verticalAlign:'middle'}}>
                <div style={{margin:'auto'}}>
                    <Button onClick={clickEv} variant="contained" style={{ float: 'right', marginLeft: '10px' }}>{evText}</Button>
                </div>
            </div>
        </Card>
    )
}

export const ContributeBias = () => {
    const navigate = useNavigate();
    return <InjectedReducedCard
        title={"Помогни ни да одредиме пристрасност"}
        description={"Политичката пристрасност се одредува со модел на машинско учење кој не е перфектен и понекогаш прави грешки, но со твоја помош може да се подобри."}
        clickEv={()=>navigate("/contribute")}
        evText={"Започни"}
        />
}

export default InjectedReducedCard;